/**
 * Vite entry point
 */
// Initialize tracking scripts early
import "./init-tracking.js";

// import "./sass/style.react.rtl.css"; // RTL version
// import "socicon/css/socicon.css";
import { createRoot } from "react-dom/client";

import axios from "axios";

import { setupAxios, setupSentry } from "_metronic";

import store from "app/store/store";

import App from "./App.jsx";

import "./index.scss"; // Standard version
// import "./_metronic/_assets/plugins/line-awesome/css/line-awesome.css";
// import "./_metronic/_assets/plugins/flaticon/flaticon.css";
// import "./_metronic/_assets/plugins/flaticon2/flaticon.css";

/**
 * Base URL of the website.
 * Vite uses import.meta.env.BASE_URL for the base path
 */
const PUBLIC_URL = import.meta.env.BASE_URL || "/";

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */

/**
 * Inject metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios);
setupSentry();

// React 18: Use createRoot instead of ReactDOM.render
const root = createRoot(document.getElementById("root"));
root.render(<App store={store} basename={PUBLIC_URL} />);
